/* istanbul ignore file */

import { FlowEntry, FlowRoute } from '../../types'

const directToMobile: FlowEntry[] = [
  {
    page: FlowRoute.Signup,
    actions: [
      {
        name: 'direct-to-mobile-lander',
        stepEvent: 'direct_to_mobile_lander',
        goTo: () => FlowRoute.DirectToMobileLander,
      },
      {
        name: 'continue',
        stepEvent: 'continue_direct_to_mobile_lander',
        goTo: () => FlowRoute.DirectToMobileLander,
      },
    ],
    progress: {
      stepIndex: 0,
      stepPartialProgress: 0,
      stepOverallProgress: 0,
    },
  },
  {
    page: FlowRoute.DirectToMobileLander,
    actions: [
      {
        name: 'skip',
        stepEvent: 'skip_direct_to_mobile',
        goTo: () => FlowRoute.PersonalInfo,
      },
    ],
    progress: {
      stepIndex: 0,
      stepPartialProgress: 0,
      stepOverallProgress: 0,
    },
  }
]

export default directToMobile
